<div class="main-layout" [class.sidebar-collapsed]="isSidebarCollapsed">
  <!-- Sidebar -->
  <app-side-bar />

  <!-- Contenedor principal -->
  <div class="main-content-container d-flex flex-column min-vh-100">
    <div class="flex-grow-1 pt-2 ps-0 pe-2">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>
